import type { FC } from 'react';
import type { FormItemProps, SelectProps } from 'antd';
import i18n from 'i18next';

import { useGetPortTypes } from '@/views/screens/common/hooks';

import FormSelectBox from '../../../../components/Inputs/FormSelectBox';

interface PortTypeSelectProps extends Pick<FormItemProps, 'rules' | 'name'>, Pick<SelectProps, 'placeholder'> {
  label?: string;
  editMode?: boolean;
  margin?: string;
  onChange?: () => void;
  onClear?: () => void;
  dataTestId?: string;
  isRequired?: boolean;
}

export const PortTypeSelect: FC<PortTypeSelectProps> = ({
  placeholder = i18n.t('translation:default.fields.portType.placeholder'),
  label = i18n.t('translation:default.fields.portType.label'),
  rules = [],
  name,
  editMode,
  margin = 'mb-0',
  onChange = () => {},
  onClear = () => {},
  dataTestId = '',
  isRequired = false,
}) => {
  const { data: options, isLoading } = useGetPortTypes();

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      onChange={onChange}
      onClear={onClear}
      dataTestId={dataTestId}
      isRequired={isRequired}
    />
  );
};
